import { HeaderNavigation } from '@/components/header/HeaderNavigation';
import { Footer } from '@/components/layout/Footer';
import React from 'react';

interface AdminLayoutProps {
  children: React.ReactNode;
}

export const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  return (
    <div className='min-h-screen bg-white flex flex-col'>
      <HeaderNavigation />
      <div className='container mx-auto p-8 space-y-6 flex-1 w-full'>
        {/* Admin navigation moved to header when in Admin-Ansicht */}
        <div className='space-y-6'>{children}</div>
      </div>
      <Footer />
    </div>
  );
};
